import {
  lucideBell,
  lucideChevronDown,
  lucideCircleCheck,
  lucideEye,
  lucideCircleUser,
  lucideDownload,
  lucideExternalLink,
  lucideFileText,
  lucideFuel,
  lucideGripVertical,
  lucideInfo,
  lucideLayoutGrid,
  lucideLifeBuoy,
  lucideLock,
  lucideMoon,
  lucidePencil,
  lucidePlus,
  lucidePlane,
  lucideRefreshCw,
  lucideSearch,
  lucideSettings,
  lucideSun,
  lucideTrash2,
  lucideTriangleAlert,
  lucideX,
} from '@ng-icons/lucide';

/**
 * The v2 icon set, declared once.
 *
 * Every v2 component passes this same record to `provideIcons`, so no component
 * imports icons ad hoc and the set stays a single reviewable list.
 */
export const V2_ICONS = {
  lucideBell,
  lucideChevronDown,
  lucideCircleCheck,
  lucideCircleUser,
  lucideDownload,
  lucideExternalLink,
  lucideEye,
  lucideFileText,
  lucideFuel,
  lucideGripVertical,
  lucideInfo,
  lucideLayoutGrid,
  lucideLifeBuoy,
  lucideLock,
  lucideMoon,
  lucidePencil,
  lucidePlane,
  lucidePlus,
  lucideRefreshCw,
  lucideSearch,
  lucideSettings,
  lucideSun,
  lucideTrash2,
  lucideTriangleAlert,
  lucideX,
};
